export const LANGUAGES = [
  { code: "en", flag: "🇬🇧", label: "English" },
  { code: "de", flag: "🇩🇪", label: "Deutsch" },
  { code: "fr", flag: "🇫🇷", label: "Français" },
  { code: "es-ES", flag: "🇪🇸", label: "Español (España)" },
  { code: "ja", flag: "🇯🇵", label: "日本語" },
  { code: "it", flag: "🇮🇹", label: "Italiano" },
  { code: "zh-Hans", flag: "🇨🇳", label: "简体中文" },
  { code: "ru", flag: "🇷🇺", label: "Русский" },
  { code: "pt-BR", flag: "🇧🇷", label: "Português (Brasil)" },
  { code: "ko", flag: "🇰🇷", label: "한국어" },
  { code: "zh-Hant", flag: "🇹🇼", label: "繁體中文" },
  { code: "pl", flag: "🇵🇱", label: "Polski" },
  { code: "es-419", flag: "🇲🇽", label: "Español (Latinoamérica)" },
  { code: "tr", flag: "🇹🇷", label: "Türkçe" },
  { code: "pt-PT", flag: "🇵🇹", label: "Português (Portugal)" },
  { code: "nl", flag: "🇳🇱", label: "Nederlands" },
  { code: "cs", flag: "🇨🇿", label: "Čeština" },
  { code: "ar", flag: "🇸🇦", label: "العربية" },
  { code: "uk", flag: "🇺🇦", label: "Українська" },
  { code: "hu", flag: "🇭🇺", label: "Magyar" },
  { code: "sv", flag: "🇸🇪", label: "Svenska" },
  { code: "th", flag: "🇹🇭", label: "ไทย" },
  { code: "da", flag: "🇩🇰", label: "Dansk" },
  { code: "no", flag: "🇳🇴", label: "Norsk" },
  { code: "fi", flag: "🇫🇮", label: "Suomi" },
  { code: "el", flag: "🇬🇷", label: "Ελληνικά" },
  { code: "ro", flag: "🇷🇴", label: "Română" },
  { code: "vi", flag: "🇻🇳", label: "Tiếng Việt" },
  { code: "bg", flag: "🇧🇬", label: "Български" },
  { code: "id", flag: "🇮🇩", label: "Bahasa Indonesia" },
  { code: "ca", flag: "🏴", label: "Català" },
  { code: "hi", flag: "🇮🇳", label: "हिन्दी" },
  { code: "sk", flag: "🇸🇰", label: "Slovenčina" },
  { code: "fa", flag: "🇮🇷", label: "فارسی" },
  { code: "ms", flag: "🇲🇾", label: "Bahasa Melayu" },
  { code: "cy", flag: "🏴", label: "Cymraeg" },
  { code: "eu", flag: "🏴", label: "Euskara" },
  { code: "hr", flag: "🇭🇷", label: "Hrvatski" },
  { code: "fil", flag: "🇵🇭", label: "Filipino" },
  { code: "lt", flag: "🇱🇹", label: "Lietuvių" },
  { code: "be", flag: "🇧🇾", label: "Беларуская" },
  { code: "he", flag: "🇮🇱", label: "עברית" },
  { code: "gl", flag: "🏴", label: "Galego" },
  { code: "sr", flag: "🇷🇸", label: "Српски" },
  { code: "et", flag: "🇪🇪", label: "Eesti" },
  { code: "sl", flag: "🇸🇮", label: "Slovenščina" },
  { code: "ka", flag: "🇬🇪", label: "ქართული" },
  { code: "ga", flag: "🇮🇪", label: "Gaeilge" },
  { code: "kk", flag: "🇰🇿", label: "Қазақша" },
  { code: "af", flag: "🇿🇦", label: "Afrikaans" },
  { code: "lv", flag: "🇱🇻", label: "Latviešu" },
  { code: "sq", flag: "🇦🇱", label: "Shqip" },
  { code: "am", flag: "🇪🇹", label: "አማርኛ" },
  { code: "hy", flag: "🇦🇲", label: "Հայերեն" },
  { code: "as", flag: "🇮🇳", label: "অসমীয়া" },
  { code: "az", flag: "🇦🇿", label: "Azərbaycan dili" },
  { code: "bn", flag: "🇧🇩", label: "বাংলা" },
  { code: "bs", flag: "🇧🇦", label: "Bosanski" },
  { code: "chr", flag: "🏴", label: "ᏣᎳᎩ" },
  { code: "fa-AF", flag: "🇦🇫", label: "دری" },
  { code: "gu", flag: "🇮🇳", label: "ગુજરાતી" },
  { code: "ha", flag: "🇳🇬", label: "Hausa" },
  { code: "is", flag: "🇮🇸", label: "Íslenska" },
  { code: "ig", flag: "🇳🇬", label: "Igbo" },
  { code: "qu", flag: "🇵🇪", label: "Runasimi" },
  { code: "kn", flag: "🇮🇳", label: "ಕನ್ನಡ" },
  { code: "km", flag: "🇰🇭", label: "ខ្មែរ" },
  { code: "rw", flag: "🇷🇼", label: "Kinyarwanda" },
  { code: "kok", flag: "🇮🇳", label: "कोंकणी" },
  { code: "ky", flag: "🇰🇬", label: "Кыргызча" },
  { code: "lb", flag: "🇱🇺", label: "Lëtzebuergesch" },
  { code: "mk", flag: "🇲🇰", label: "Македонски" },
  { code: "ml", flag: "🇮🇳", label: "മലയാളം" },
  { code: "mt", flag: "🇲🇹", label: "Malti" },
  { code: "mi", flag: "🇳🇿", label: "Te Reo Māori" },
  { code: "mr", flag: "🇮🇳", label: "मराठी" },
  { code: "mn", flag: "🇲🇳", label: "Монгол" },
  { code: "ne", flag: "🇳🇵", label: "नेपाली" },
  { code: "or", flag: "🇮🇳", label: "ଓଡ଼ିଆ" },
  { code: "pa", flag: "🇮🇳", label: "ਪੰਜਾਬੀ" },
  { code: "pa-Arab", flag: "🇵🇰", label: "پنجابی" },
  { code: "quz", flag: "🇵🇪", label: "Runa Simi" },
  { code: "gd", flag: "🏴", label: "Gàidhlig" },
  { code: "sd", flag: "🇵🇰", label: "سنڌي" },
  { code: "si", flag: "🇱🇰", label: "සිංහල" },
  { code: "ckb", flag: "🇮🇶", label: "سۆرانی" },
  { code: "st", flag: "🇱🇸", label: "Sesotho" },
  { code: "sw", flag: "🇹🇿", label: "Kiswahili" },
  { code: "tg", flag: "🇹🇯", label: "Тоҷикӣ" },
  { code: "ta", flag: "🇮🇳", label: "தமிழ்" },
  { code: "tt", flag: "🇷🇺", label: "Татарча" },
  { code: "te", flag: "🇮🇳", label: "తెలుగు" },
  { code: "ti", flag: "🇪🇷", label: "ትግርኛ" },
  { code: "tn", flag: "🇧🇼", label: "Setswana" },
  { code: "tk", flag: "🇹🇲", label: "Türkmençe" },
  { code: "ur", flag: "🇵🇰", label: "اردو" },
  { code: "ug", flag: "🇨🇳", label: "ئۇيغۇرچە" },
  { code: "uz", flag: "🇺🇿", label: "Oʻzbekcha" },
  { code: "ca-ES-valencia", flag: "🇪🇸", label: "Valencià" },
  { code: "wo", flag: "🇸🇳", label: "Wolof" },
  { code: "xh", flag: "🇿🇦", label: "isiXhosa" },
  { code: "yo", flag: "🇳🇬", label: "Yorùbá" },
  { code: "zu", flag: "🇿🇦", label: "isiZulu" },
];
